module.exports = __webpack_public_path__ + "img/favicon.5f613bb5.jpg";